const PRODUCTION_APP_HOST = 'app.testera.io';
const PRODUCTION_MARKETING_HOSTS = ['testera.io', 'www.testera.io'];
// Subdomains that can never be tenant portals
const RESERVED_SUBDOMAINS = ['app', 'www', 'admin', 'mcp', 'api', 'autodiscover', 'mail', 'mt35', 'mt-link'];

export function getHostname() {
  return typeof window !== 'undefined' ? window.location.hostname : '';
}

/**
 * Tenant slug when running on a branded subdomain (<slug>.testera.io),
 * or '' when on the main app/marketing/admin hosts.
 * Local dev: <slug>.localhost works out of the box in modern browsers.
 */
export function getTenantSlug(host = getHostname()) {
  const prod = /^([a-z0-9-]+)\.testera\.io$/.exec(host);
  if (prod && !RESERVED_SUBDOMAINS.includes(prod[1])) return prod[1];
  const dev = /^([a-z0-9-]+)\.localhost$/.exec(host);
  if (dev && !RESERVED_SUBDOMAINS.includes(dev[1])) return dev[1];
  return '';
}

export function isAppHost(host = getHostname()) {
  return host === PRODUCTION_APP_HOST || host === 'app.localhost' || !!getTenantSlug(host);
}

export function isMarketingHost(host = getHostname()) {
  return PRODUCTION_MARKETING_HOSTS.includes(host);
}

export function isLocalDevHost(host = getHostname()) {
  return host === 'localhost' || host === '127.0.0.1';
}

export function isAdminHost(host = getHostname()) {
  return host === 'admin.testera.io'
    || host === 'admin.localhost'
    || (host === 'localhost' && typeof window !== 'undefined' && window.location.port === '4000');
}

/** Origin for the app portal (app.testera.io in production). */
export function getAppOrigin() {
  if (typeof window !== 'undefined') {
    const host = getHostname();
    if (isAppHost(host)) {
      return window.location.origin;
    }
    if (isLocalDevHost(host)) {
      const path = window.location.pathname || '/';
      if (path === '/app' || path.startsWith('/app/')) {
        return window.location.origin;
      }
      return `${window.location.origin}/app`;
    }
  }
  return 'https://app.testera.io';
}

/** URL for marketing CTAs that should open the portal login screen. */
export function portalLoginUrl() {
  return appUrl('/', { hash: 'login' });
}

export function appUrl(path = '/', { search = '', hash = '' } = {}) {
  const origin = getAppOrigin();
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const query = search
    ? (search.startsWith('?') ? search : `?${search}`)
    : '';
  const fragment = hash
    ? (hash.startsWith('#') ? hash : `#${hash}`)
    : '';
  return `${origin}${normalizedPath}${query}${fragment}`;
}

/** Navigate to the app subdomain (used from marketing host). */
export function redirectToApp(path = '/', { search = '', hash = '' } = {}) {
  if (typeof window === 'undefined') return;
  window.location.replace(appUrl(path, { search, hash }));
}
